module.exports = __webpack_public_path__ + "img/YouTube.b02c1683.svg";